"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var range_utils_1 = require("./range-utils");
exports.getRange = range_utils_1.getRange;
exports.ELLIPSIS = range_utils_1.ELLIPSIS;
exports.FIRST_PAGE = range_utils_1.FIRST_PAGE;
exports.ONE_PAGE = range_utils_1.ONE_PAGE;
//# sourceMappingURL=index.js.map